import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import locale_th from 'dayjs/locale/th';
dayjs.extend(relativeTime);
dayjs.extend(weekOfYear);

export function getAccumulationTimeSlip(accumulation, type, timeSlip) {
    if(!accumulation){
        return 0;
    }
    let dateCode = '';
    if(timeSlip === 'day'){
        dateCode = dayjs().locale(locale_th).format('DDMMYYYY');
    } else if(timeSlip === 'hour') {
        dateCode = dayjs().locale(locale_th).format('HHDDMMYYYY');
    } else if(timeSlip === 'week') {
        dateCode = dayjs().locale(locale_th).week();
    } else if(timeSlip === 'month') {
        dateCode = dayjs().locale(locale_th).format('MMYYYY');
    }

    let key = ''+type+'_'+dateCode;
    return accumulation[key] || 0;
}

export function getTimeSlip(type, timeSlip) {
    if(timeSlip === 'day'){
        const dateCode = dayjs().locale(locale_th).format('DDMMYYYY');
        return ''+type+'_'+dateCode;
    } else if(timeSlip === 'hour') {
        const dateCode = dayjs().locale(locale_th).format('HHDDMMYYYY');
        return ''+type+'_'+dateCode;
    } else if(timeSlip === 'week') {
        const dateCode = dayjs().locale(locale_th).week();
        return ''+type+'_'+dateCode;
    } else if(timeSlip === 'month') {
        const dateCode = dayjs().locale(locale_th).format('MMYYYY');
        return ''+type+'_'+dateCode;
    }
}

export function TimeFromNow(props) {
    const { i18n } = useTranslation();
    const currentLang = i18n.language.split('-')[0] || 'en';
    let [display, setDisplay] = useState('');
    useEffect(() => {
        console.log('[TimeFromNow]');
        if(currentLang === 'th'){
            let newValue = dayjs(props.value).locale(locale_th).fromNow();
            setDisplay(newValue);
        } else {
            let newValue = dayjs(props.value).fromNow();
            setDisplay(newValue);
        }

    }, [props, currentLang, setDisplay]);

    return(
        <>
        {props.value &&
            <span>
                {display}
            </span>
        }
        </>
    )
}